import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { AppSettings } from '../app-settings';
import { SidePanelCard } from '../models/side-panel-card';
import { HttpClientService } from './http-client.service';

const SIDE_PANEL_TIMEOUT_MS = 8000;

/** Loads the side panel cards for a course page. Never fails: on error or timeout the page gets no cards. */
@Injectable({ providedIn: 'root' })
export class SidePanelService {

  constructor(private httpClientService: HttpClientService) { }

  getCards(pageName: string): Observable<SidePanelCard[]> {
    if (!pageName) {
      return of([]);
    }
    const url = AppSettings.restApiUrl + '/api/liveSessions?page=' + encodeURIComponent(pageName);
    return this.httpClientService.get(url, new HttpHeaders()).pipe(
      timeout(SIDE_PANEL_TIMEOUT_MS),
      map((rows: any[]) => (rows || []).map(row => ({
        id: row.id,
        html: row.webinarText,
        designLanguage: row.designLanguage === 'PRISM' ? 'PRISM' : 'CLASSIC'
      } as SidePanelCard))),
      catchError(() => of([]))
    );
  }
}
